import { observer } from 'mobx-react-lite';
import { useStores } from '@stores/context.jsx';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EBlurEffectStates } from '@common/DetailsSideBar/DetailsSideBar.constants.js';
import Details from './Details.jsx';
import DetailsSideBar from '@common/DetailsSideBar/DetailsSideBar.jsx';

const VehicleDetailSidebar = observer((props) => {
    const { serviceStore, remoteMessageStore } = useStores();
    const { deviceId } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const close = async () => {
        navigate(`${serviceStore.currentService}/vehicles${location.search}`);
    };
    return (
        <DetailsSideBar
            title={`${t("fotaone.general.vehicleData.vehicleDetails")}`}
            onClose={close}
            width={600}
            blurEffect={remoteMessageStore.vehicleDetailsLoading === true ? EBlurEffectStates.Show : EBlurEffectStates.Hide}
            fly
        >
            <Details deviceId={deviceId} />
        </DetailsSideBar>
    );
});

export default VehicleDetailSidebar;